import { render } from "./travel-auth-valid.vue?vue&type=template&id=5a6371a2"
import script from "./travel-auth-valid.vue?vue&type=script&lang=js"
export * from "./travel-auth-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__